import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import Process from "@/components/Process";
import Atelier from "@/components/Atelier";
import GoogleReviews from "@/components/GoogleReviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="overflow-x-clip bg-[#FAFBFD] font-sans text-slate-900 antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Pricing />
        <Process />
        <Atelier />
        <GoogleReviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
